// admin.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
// import { AdminComponent } from './components/admin/admin.component';
import { HomeComponent } from './components/admin/home/home.component';
import { DashboardComponent } from './components/admin/dashboard/dashboard.component';
import { ManageProductComponent } from './components/admin/manage-product/manage-product.component';
import { ManageCustomerComponent } from './components/admin/manage-customer/manage-customer.component';
import { ManageCategoriesComponent } from './components/admin/manage-categories/manage-categories.component';
import { MatDialogModule, } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AdminAuthModule } from './components/admin/admin-utils/admin-auth.module';
import { AdminCallbackComponent } from './components/admin/admin-utils/admin-callback/admin-callback.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth/auth.interceptor';
import { LogoutComponent } from './components/admin/admin-utils/logout/logout.component';
import { LoginComponent } from './components/admin/admin-utils/login/login.component';
import { AdminAuthGuard } from './components/admin/admin-utils/auth-guard/auth-guard.component';
import { ProductDetailComponent } from './components/admin/product-detail/product-detail.component';
import { VariantDetailComponent } from './components/admin/variant-detail/variant-detail.component';
import { ManageProductGroupComponent } from './components/admin/manage-product-group/manage-product-group.component';
import { ManageOrderComponent } from './components/admin/manage-order/manage-order.component';
import { RbacGuard } from './components/admin/admin-utils/rbac-guard/rbac.guard';
import { ManageRbacRolesComponent } from './components/admin/manage-rbac-roles/manage-rbac-roles.component';
import { FeedMappingComponent } from './components/admin/feed/feed-field-mappings/feed-field-mappings.component';
import { FeedListComponent } from './components/admin/feed/feed-list/feed-list.component';
import { FeedProductDetailComponent } from './components/admin/feed/feed-product-detail/feed-product-detail.component';
import { FeedDestinationSelectComponent } from './components/admin/feed/feed-destination-select/feed-destination-select.component';
import { ManageFeedsComponent } from './components/admin/feed/manage-feeds/manage-feeds.component';
import { PlatformAdminGuard } from './util/auth-guard/platform-guard.guard';
import { ManageTenantComponent } from './components/platform-admin/manage-tenant/manage-tenant.component';
import { ManageUsersComponent } from './components/admin/manage-users/manage-users.component';

export const routes: Routes = [
  { path: '', redirectTo: 'admin/home', pathMatch: 'full' },
  {
    path: 'admin',
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full', },
      { path: 'home', component: HomeComponent, },
      { path: 'logout', component: LogoutComponent },
      { path: 'login', component: LoginComponent },
      //protected routes
      { path: 'admin-dashboard', component: DashboardComponent },
      { path: 'manage-products', component: ManageProductComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-products/:productId', component: ProductDetailComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-products/:productId/variant/:variantId', component: VariantDetailComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-customers', component: ManageCustomerComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-categories', component: ManageCategoriesComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-product-groups', component: ManageProductGroupComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-order', component: ManageOrderComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-rbac-roles', component: ManageRbacRolesComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-feeds', component: ManageFeedsComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'manage-users', component: ManageUsersComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'feed-mapping/:destination', component: FeedMappingComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'feeds', component: FeedListComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'feeds/product/:productId', component: FeedDestinationSelectComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'platform/manage-tenants', component: ManageTenantComponent, canActivate: [PlatformAdminGuard], runGuardsAndResolvers: 'always' },
      { path: 'feeds/product/:productId/edit', component: FeedProductDetailComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      // { path: 'feeds/product/:productId', component: FeedProductDetailComponent, canActivate: [AdminAuthGuard], runGuardsAndResolvers: 'always' },
      { path: 'admin-callback', component: AdminCallbackComponent },
      { path: 'manage-orders', component: ManageOrderComponent },

      // { path: 'manage-orders/:order_id', component: OrderDetailComponent }
      { path: '**', redirectTo: 'admin/home' }

    ],
  },
];

@NgModule({
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  }],
  imports: [CommonModule, RouterModule.forChild(routes), MatDialogModule, MatIconModule, AdminAuthModule],
})
export class AdminModule { }
